export default {
  props: [
    "headers",
    "items",
    "filter",
    "noDataText",
    "buttonText",
    "dialog",
    "listType",
    "loading",
    "isUserList"
  ],
  data: () => ({
    itemsPerPage: 10,
    pageCount: 0,
    page: 1
  }),
  methods: {
    setToLocalStorage(value) {
      localStorage.setItem("itemsPerPage", value);
    },
    nextPage() {
      const total = this.items?.length || 0;
      const totalPages = Math.ceil(total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  },
  computed: {
    tableOptions: {
      get() {
        // eslint-disable-next-line no-unused-vars
        const { searchText, ...filter } = this.filter;
        return filter;
      },
      set(value) {
        value.limit = value.itemsPerPage;
        const sortDirection = value?.sortDesc?.[0] ? "desc" : "asc";

        value.sort = value?.sortBy?.[0] ?? "start";
        value.direction = sortDirection;

        this.$emit("applyFilter", {
          ...this.filter,
          ...value
        });
      }
    }
  }
};
